import React from 'react'
import { useSelector } from 'react-redux'
import { View } from 'react-native'
import { Feature, useFeatureFlag } from '@src/components/FeatureFlag'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { EhrAppointmentSchedulingMode } from '@src/types'
import { ehrAppointmentSchedulingInfoSelector } from '../../models/nutritionistHub.selectors'
import { ScheduleNextCallActions } from './ScheduleNextCallActions'
import { ScheduleNextCallButton } from './ScheduleNextCallButton'

export const ScheduleNextCallCard = () => {
  const styles = useStyleSheet(themedStyles)
  const appointmentSchedulingInfo = useSelector(ehrAppointmentSchedulingInfoSelector)

  const serviceCentricAppointmentSchedulerEnabled = useFeatureFlag(
    Feature.ServiceCentricAppointmentScheduler,
  )

  const { mnt, stressManagement } = appointmentSchedulingInfo ?? {}
  const canScheduleMnt =
    mnt?.schedulingMode && mnt.schedulingMode !== EhrAppointmentSchedulingMode.None
  const canScheduleStressManagement =
    stressManagement?.schedulingMode &&
    stressManagement.schedulingMode !== EhrAppointmentSchedulingMode.None

  if (
    serviceCentricAppointmentSchedulerEnabled &&
    (canScheduleMnt || canScheduleStressManagement)
  ) {
    // New schedule button
    return <ScheduleNextCallButton />
  }

  if (!serviceCentricAppointmentSchedulerEnabled && canScheduleMnt) {
    // Original scheduler
    return (
      <View style={styles.container}>
        <Text type="title-3">Schedule your next call</Text>

        <ScheduleNextCallActions schedulingInfo={mnt} />
      </View>
    )
  }

  // Scheduling not available right now
  return null
}

const themedStyles = StyleService.create({
  container: {
    paddingTop: 12,
    paddingBottom: 12,
  },
})
